import Backend from 'backend';
import {inject} from 'aurelia-framework';
import {Redirect, Router} from 'aurelia-router';
import {UserInfoProvider} from "../util/user-info-provider";
import {ShoppingCart} from "./checkout-flow/shopping-cart";
import {IdentityProvider} from "devtag-aurelia-auth-plugin";
import {NotificationService} from "../util/notification-service";

@inject(Backend, Router, UserInfoProvider, IdentityProvider, NotificationService, ShoppingCart)
export class QuickpayRedirectRoute {
  backend;
  router;
  userInfoProvider;
  identityProvider;
  notificationService;
  shoppingCart;

  constructor(backend, router, userInfoProvider, identityProvider, notificationService, shoppingCart) {
    this.backend = backend;
    this.router = router;
    this.userInfoProvider = userInfoProvider;
    this.identityProvider = identityProvider;
    this.notificationService = notificationService;
    this.shoppingCart = shoppingCart;
  }

  canActivate(params) {
    switch (params.state) {
      case 'payment_confirmed':
        // Clear the payment link since it has been used and cannot be used again.
        this.shoppingCart.load()
            .then(() => {
              this.shoppingCart.clearPaymentLink();
            });

        // Verify payment means in backend
        return this.backend.VerifyPaymentMeansQueryHandler_handle_v2({redirectReference: params.redirectReference})
          .then(result => {
            // Assert sanity
            if (result.ok !== true) {
              throw new Error("Got redirected back from qp with continue_url, but payment means could not be verified by backend.");
            }

            // Warn if not logged in
            let isLoggedIn = this.identityProvider.isCurrentlyLoggedIn();
            if (!isLoggedIn) {
              // Why would the user not be logged in when returning from Quickpay?
              // We discovered that a number of users were browsing raago.no in Instagram or Facebook in-app browsers
              // but were redirected to their phones default browser when returning from Vipps.
              // We can't really do anything about this, other than make sure the payment means is still verified properly.
              this.notificationService.showOnNextRouterSuccess(
                'Du startet kjøpet i en annen nettleser enn vipps nå sendte deg tilbake til. ' +
                'Du må derfor desverre logge inn og velge varer på nytt, men betalingsmiddelet du opprettet skal nå være registrert hos oss.');
            }

            // Happy path: redirect to checkout-flow. Checkout flow will automatically go to payment step if that is where user was before he left.
            this.router.navigateToRoute('checkout-flow', {state: 'payment_means_verified', paymentMeansId: result.paymentMeansId});
            // return new Redirect('checkout-flow', {state: 'payment_means_verified', paymentMeansId: result.paymentMeansId});
          });
      case 'payment_cancelled':
      default:
        throw new Error("Quickpay redirect url did not expect state: [" + params.state + "].");
    }
  }
}
